<template>
  <v-sheet class="d-flex flex-column align-items-center pa-2 ma-2 fill-height" outlined>

  <v-sheet class="text-center ma-2" style="font-size: 1rem; font-weight: bold">
      {{title}}
      <span v-if="metap" class="ml-1">(metap: {{ metap }})</span>
    </v-sheet>
    <v-sheet class="d-flex justify-center">
      <img
          v-if="imageSrc"
          :src="imageSrc"
          :alt="title || 'omics abundance image'"
          class="ma-4"
          style="max-height: 50vh; width: 90%;"
      />
      <v-sheet
          v-else
          class="d-flex justify-center align-center grey--text text--darken-1"
          style="height: 50vh;"
      >
        No data available
      </v-sheet>
    </v-sheet>
  </v-sheet>
</template>

<script>
export default {
  name: "TNomicsAbundance",
  props: {
    imageSrc: {
      type: String,
      default: null,
    },
    metap: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

